export default __webpack_public_path__ + "static/Salesforce-eefde84d7df8d10771ed49bb22c09352.svg";